import { render, staticRenderFns } from "./RechargeRule.vue?vue&type=template&id=67c51748&"
import script from "./RechargeRule.vue?vue&type=script&lang=js&"
export * from "./RechargeRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports